import { Component, Input } from '@angular/core';
import { MenuItem } from '../../models/menu-item.model';
import { SlideMenuService } from '../../services/slide-menu/slide-menu.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent {

  @Input() menuData: Array<MenuItem> = [];

  constructor(
    public slideMenuService: SlideMenuService
  ) { }

}
